module.exports = __webpack_public_path__ + "assets/img/skan_logo_no_bg.e39df739.png";